"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LocalStorage =
/** @class */
function () {
  function LocalStorage(name) {
    this.name = name;

    if (!window || !window.localStorage) {
      throw new Error('The localStorage is not present.');
    }
  }

  LocalStorage.prototype.setGridName = function (name) {
    this.name = name;
  };

  LocalStorage.prototype.setTextSearch = function (textSearch) {
    window.localStorage.setItem(this.name + "_textSearch", textSearch);
  };

  LocalStorage.prototype.setPage = function (page) {
    window.localStorage.setItem(this.name + "_page", page.toString());
  };

  LocalStorage.prototype.setColumns = function (columns) {
    window.localStorage.setItem(this.name + "_columns", JSON.stringify(columns));
  };

  LocalStorage.prototype.getTextSearch = function () {
    return window.localStorage.getItem(this.name + "_textSearch");
  };

  LocalStorage.prototype.getPage = function () {
    return parseInt(window.localStorage.getItem(this.name + "_page"), 10);
  };

  LocalStorage.prototype.getColumns = function () {
    return JSON.parse(window.localStorage.getItem(this.name + "_columns"));
  };

  return LocalStorage;
}();

exports.LocalStorage = LocalStorage;